<template>
  <div class="tableWithPerPageSelection">
    <a ref="lienDownload"></a>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeCommandeTlpe.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllCommandeTlpeSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-5 pdr-0">
            <b-input :placeholder="$t('general.button.search')"
                     type="search" icon="magnify" v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.COMMANDE_TLPE.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <v-server-table url=""
      :columns="columns" :options="options" :ref="referenceTable"
      v-if="startArrayRendering && mountedLoadingEnd"
      @loaded="finLoading" @loading="debutLoading">
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"/>
      </div>
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="commandesTlpe">
        </table-footer-totaux>
      </template>
      <div slot="code" slot-scope="props">
        <router-link-blank :to="{ name: 'c.gabed.commande_tlpe',
                                      params: { id: props.row.id }}"
                           class="lien"
                           :message="props.row.code">
        </router-link-blank>
      </div>
      <div slot="declarant" slot-scope="props">
        {{ getNomPrenomCommercial(props.row.commercial) }}
      </div>
      <div slot="annee" slot-scope="props">
        {{ props.row.anneeDeclaration }}
      </div>
      <div slot="collectivite" slot-scope="props">
        {{ props.row.intervenants ? props.row.intervenants[0].nomCommercial : null }}
      </div>
      <div slot="adresse" slot-scope="props">
        {{ props.row.intervenants ? props.row.intervenants[0].adressePostale.adresse1 : ''}}
      </div>
      <div slot="departement" slot-scope="props" class="has-text-centered">
        {{ props.row.intervenants ? props.row.intervenants[0].adressePostale.departement : ''}}
      </div>
      <div slot="ville" slot-scope="props">
        {{ props.row.intervenants ? props.row.intervenants[0].adressePostale.ville : ''}}
      </div>
      <div slot="codePostal" slot-scope="props" class="has-text-centered">
        {{ props.row.intervenants ? props.row.intervenants[0].adressePostale.codePostal : ''}}
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getLibelleEtat(props.row.etat)) }}
      </div>
      <div slot="typeDeclaration" slot-scope="props">
        {{ $t(getLibelleTypeDeclaration(props.row.typeDeclaration)) }}
      </div>
      <div slot="dateDeclaration" slot-scope="props">
        {{ props.row.dateDevisCommande | formatDate }}
      </div>
      <div slot="montantTtc" slot-scope="props" class="is-pulled-right">
        {{ props.row.montantTtc | formatDevise }}
      </div>
      <div slot="exporter" slot-scope="props">
        <a @click="checkPermissions(constantes.COMMANDE_TLPE.editer) ?
          editionCerfa(props.row.id) : showPopUp()">
          <b-icon
            :key="props.id"
            icon="file-pdf-box"
            type="is-primary"
            :class="{'text-access-no-permission' :
            !checkPermissions(constantes.COMMANDE_TLPE.editer)}">
          </b-icon>
        </a>
      </div>
      <div slot="edit" slot-scope="props">
        <router-link :to="{
            name: 'm.gabed.commande_tlpe-edition',
            params: { id: props.row.id } }">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.COMMANDE_TLPE.maj) }"></b-icon>
        </router-link>
      </div>
      <div slot="delete" slot-scope="props">
        <div @click="checkPermissions(constantes.COMMANDE_TLPE.supprimer)
        ? openPopUpSuppresion(props.row.id) : showPopUp()"
             class="is-cursor-pointer">
          <b-icon type="is-danger" icon="delete-forever" :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.COMMANDE_TLPE.supprimer) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-liste-commande-tlpe ref="filtreListeCommandeTlpe"
                                  @toggleFiltre="setShowFiltre"
                                  @recherche="makeRechercheFilter">
      </filtre-liste-commande-tlpe>
    </div>
    <b-modal v-model="popUpSuppresion"
             has-modal-card
             class="modal">
      <pop-up-prevention
        @no="popUpSuppresion = false;"
        @yes="suppression"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.oui')"
        :mess-header="$t('detailCommandeTlpe.suppression.title')">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="choiceEdition"
        @editionChoose="edition"
      >
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { COMMANDE_TLPE } from '@/configuration/gabed/permissionsGabedConf';
import breadcrumb from '@/components/general/breadcrumb';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import inProgress from '@/services/general/inProgress';
import subscribeMutation from '@/services/store/subscribeMutation';
import messageErreur from '@/services/general/messageErreur';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import editionCerfaAsync from '@/services/gabed/commandeTlpe/editionCerfaCommandeTlpe';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import * as devisConf from '@/configuration/devisConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import {
  LISTE_TYPE_DECLARATION,
  EXPORT_EXCEL_COMMANDE_TLPE,
  LISTE_TYPE_DECLARATION_AU_FIL_DE_LEAU,
  LISTE_TYPE_DECLARATION_CLASSIQUE,
  LISTE_CHOIX_EDITION_DECLARATIONS_TLPE,
  TYPE_EDITION_COMMANDE_R_TLPE,
  TYPE_EDITION_COURRIER,
} from '@/configuration/gabed/tlpe/tlpeConf';
import filtreListeCommandeTlpe from '@/components/gabed/commandeTlpe/filtreListeCommandeTlpe';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { remove } from '@/api/gabed/commandeTlpe';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import selecteurAction from '@/components/general/selecteurAction';
import transformer from '@/services/gabed/commandeTlpe/commandeTlpeServerTableDataTransformer';
import { ACTION_MASS_EDITION } from '@/configuration/general/actionsConf';
import popUpEdition from '@/components/factures/p_edition';
import edition from '@/api/edition/index';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_COMMANDES_TLPE } from '@/configuration/general/referenceTableConf';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const CommandeTlpe = createNamespacedHelpers('commandeTlpe');

export default {
  data() {
    return {
      showFiltre: false,
      unsubscribeValue: null,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      idCommandeToDelete: null,
      popUpSuppresion: false,
      constantes: {
        COMMANDE_TLPE,
        TYPE_EDITION_COMMANDE_R_TLPE,
        TYPE_EDITION_COURRIER,
      },
      actions: [
        { action: ACTION_MASS_EDITION, translation: 'declarationTlpe.actions.genererEdition' },
      ],
      openPopUpEdition: false,
      choiceEdition: LISTE_CHOIX_EDITION_DECLARATIONS_TLPE,
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      referenceTable: REFERENCE_TABLE_COMMANDES_TLPE,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    breadcrumb,
    TableItemsInView,
    filtreListeCommandeTlpe,
    routerLinkBlank,
    popUpPrevention,
    selecteurAction,
    popUpEdition,
    tableFooterTotaux,
    parametrageTable,
    exportExcelButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...CommandeTlpe.mapGetters({
      criteresRecherche: 'criteresRecherche',
      total: 'total',
      commandesTlpe: 'items',
      lastPayload: 'lastPayload',
    }),
    nombreCritere() {
      const banCritere = ['auto'];
      return calculNombreCritere(this.criteresRecherche, banCritere);
    },
    targetTotal() {
      return ['montantTtc'];
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeCommandeTlpe.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeCommandeTlpe.tab.code'),
          annee: this.$i18n.t('listeCommandeTlpe.tab.annee'),
          codeDossier: this.$i18n.t('listeCommandeTlpe.tab.codeDossier'),
          declarant: this.$i18n.t('listeCommandeTlpe.tab.declarant'),
          etat: this.$i18n.t('listeCommandeTlpe.tab.etat'),
          collectivite: this.$i18n.t('listeCommandeTlpe.tab.collectivite'),
          typeDeclaration: this.$i18n.t('listeCommandeTlpe.tab.typeDeclaration'),
          dateDeclaration: this.$i18n.t('listeCommandeTlpe.tab.dateDeclaration'),
          departement: this.$i18n.t('listeCommandeTlpe.tab.departement'),
          adresse: this.$i18n.t('listeCommandeTlpe.tab.adresse'),
          codePostal: this.$i18n.t('listeCommandeTlpe.tab.codePostal'),
          ville: this.$i18n.t('listeCommandeTlpe.tab.ville'),
          montantTtc: this.$i18n.t('listeCommandeTlpe.tab.montantTtc'),
          exporter: '',
          edit: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          if (data.query.annee) {
            data.query.anneesDeclaration = [data.query.annee];
            delete data.query.annee;
          }
          if (!data.query.etat || data.query.etat.length === 0) {
            data.query.etat = [
              devisConf.ETAT_ENREGISTRE,
              devisConf.ETAT_FACTURE,
              devisConf.ETAT_FACTURE_PARTIELLEMENT,
            ];
          }
          data.query.societeId = this.societeActiveId;
          return this.loadCommandeTlpe(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.commandesTlpe,
            count: this.total,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          exporter: 'colonneSelected',
          delete: 'colonneSelected',
          selected: 'colonneSelected',
        },
        sortable: ['code', 'codeDossier', 'dateDeclaration', 'montantTtc'],
      };
    },
    columns() {
      return ['selected', 'code', 'annee', 'declarant', 'collectivite', 'adresse', 'codePostal', 'ville', 'departement', 'etat', 'typeDeclaration', 'dateDeclaration', 'codeDossier', 'montantTtc', 'exporter', 'edit', 'delete'];
    },
    iconSelectTotal() {
      if (this.allCommandesTlpeSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    allCommandesTlpeSelected() {
      return this.getAllCommandeTlpeSelected().length === this.commandesTlpe.length
        && this.commandesTlpe.length > 0;
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_COMMANDE_TLPE,
        typeExport: '',
        filtres: transformer(this.lastPayload),
      };
    },
  },
  methods: {
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...CommandeTlpe.mapActions({
      loadCommandeTlpe: 'loadCommandeTlpe',
    }),
    openPopUpSuppresion(id) {
      this.idCommandeToDelete = id;
      this.popUpSuppresion = true;
    },
    async suppression() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await remove(this.idCommandeToDelete);
        messageSucces(this.$t('listeCommandeTlpe.messages.success.suppression'));
        this.popUpSuppresion = false;
        this.idCommandeToDelete = null;
        loadingComponent.close();
        this.goFirstPage();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async editionCerfa(commandeId) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const commandesId = [];
        commandesId.push(commandeId);
        await editionCerfaAsync(commandesId, this.$refs.lienDownload);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    getLibelleTypeDeclaration(codeTypeDeclaration) {
      const typeDeclarationFind = LISTE_TYPE_DECLARATION.find((t) => {
        return t.code === codeTypeDeclaration;
      });
      return typeDeclarationFind ? typeDeclarationFind.libelle : '';
    },
    getLibelleEtat(codeEtat) {
      const etatFind = devisConf.DEVIS_COMMANDE_ETAT.find((e) => {
        return e.code === codeEtat;
      });
      return etatFind ? etatFind.libelle : '';
    },
    getNomPrenomCommercial(commercial) {
      if (!commercial) return '';
      return nomPrenomGetter(commercial);
    },
    getAllCommandeTlpeSelected() {
      return this.commandesTlpe.filter((el) => {
        return el.selected;
      });
    },
    selectAll() {
      const select = !this.allCommandesTlpeSelected;
      this.commandesTlpe.forEach(item => {
        item.selected = select;
      });
    },
    handleAction(action) {
      switch (action) {
        case ACTION_MASS_EDITION:
          if (this.checkPermissions(this.constantes.COMMANDE_TLPE.editer)) {
            this.openPopUpEdition = true;
          } else this.showPopUp();
          break;
        default:
          break;
      }
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    async reinitialiser() {
      await this.$refs.filtreListeCommandeTlpe.initializeFiltre();
      this.$refs.filtreListeCommandeTlpe.viderCritere();
      this.$refs.filtreListeCommandeTlpe.appliquerCritere();
      this.showFiltre = false;
      this.setLockMenu(this.showFiltre);
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeCommandeTlpe.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async editionCourrier(ids, donnees) {
      const response = await edition({
        ids: ids,
        extension: donnees.format,
        typeDonnee: donnees.typeDonnee,
        typeEdition: '',
      });
      const link = this.$refs.lienDownload;
      link.href = window.URL.createObjectURL(response.data);
      const disposition = response.request.getResponseHeader('Content-Disposition');
      link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
      link.click();
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEdition.champsVide = [];
        this.errorEdition.messagesChampsVide = [];
        this.errorEdition.messages = [];
        this.errorEdition.haveError = false;
        const commandesTlpe = this.getAllCommandeTlpeSelected();
        const commandesId = commandesTlpe.map((commandeTlpe) => {
          return commandeTlpe.id;
        });
        switch (donnees.typeDonnee) {
          case this.constantes.TYPE_EDITION_COMMANDE_R_TLPE:
            await editionCerfaAsync(commandesId, this.$refs.lienDownload);
            break;
          case this.constantes.TYPE_EDITION_COURRIER:
            await this.editionCourrier(commandesId, donnees);
            break;
          default:
            break;
        }
        this.openPopUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      if (this.$route.params.annee) this.criteresRecherche.annee = this.$route.params.annee;
      if (this.$route.params.tiersId) {
        this.criteresRecherche.tiersId = [this.$route.params.tiersId];
      }
      if (this.$route.params.isFilDeLeau !== undefined) {
        this.criteresRecherche.typesDeclaration = this.$route.params.isFilDeLeau === 'true'
          ? LISTE_TYPE_DECLARATION_AU_FIL_DE_LEAU.map(i => i.code)
          : LISTE_TYPE_DECLARATION_CLASSIQUE.map(i => i.code);
      }
      this.mountedLoadingEnd = true;
      this.setInformationPage(this.$t('pagePatrimoine.commandeTlpe.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
